import React from 'react';
import VendorDashboard from './components/VendorDashboard';

function App() {
  return <VendorDashboard />;
}

export default App;
